<template>
  <div class="limit-seckill" v-if="seckillList && seckillList.length">
    <div class="limit-seckill-top">
      <img src="//image01.homedo.com/Files/Images/cms/www/20241209/5676172079421677153_pic1.png" alt="">
      每周推荐</div>
    <swiper :options="seckillList.length > 1 ? swiperOption : swiperOptionOne"  v-if="seckillList && seckillList.length">
      <swiper-slide v-for="(item, index) in seckillList" :key="index">
        <div class="seckill-item">
          <div class="seckill-project">
            <div class="seckill-project-left" @click="goDetail(item)">
                <img v-if="item.suffixes && item.suffixes.length > 1" class="solution-item-icon" src="//image01.homedo.com/Files/Images/cms/www/20190805/5257706577996993572_pic1.png" alt="">
                <img v-else-if="item.suffixes[0] == 'ppt' || item.suffixes[0] == 'pptx'" class="solution-item-icon" src="//image01.homedo.com/Files/Images/cms/www/20190805/5480198852448354363_pic1.png" alt="">
                <img  v-else-if="item.suffixes[0] == 'doc' || item.suffixes[0] == 'docx'" class="solution-item-icon" src="//image01.homedo.com/Files/Images/cms/www/20190805/5065556020444862923_pic1.png" alt=""/>
                <img  v-else-if="item.suffixes[0] == 'pdf'" class="solution-item-icon" src="//image01.homedo.com/Files/Images/cms/www/20190805/4714196104133310148_pic1.png" alt=""/>
                <img v-else-if="item.suffixes[0] == 'xls' || item.suffixes[0] == 'xlsx'" class="solution-item-icon" src="//image01.homedo.com/Files/Images/cms/www/20190805/4882573325853164862_pic1.png"alt=""/>
                <img v-else-if="item.suffixes[0] == 'dwg'" class="solution-item-icon" src="//image01.homedo.com/Files/Images/cms/www/20190805/4872871580678586404_pic1.png" alt=""/>
                <img v-else class="solution-item-icon" src="//image01.homedo.com/Files/Images/cms/www/20190807/4919828709543073167_pic1.png" alt=""/>
            </div>
            <div class="seckill-project-right">
                  <div  class="seckill-info-title" @click="goDetail(item)">{{item.bizName}}</div>
                  <div class="seckill-money-box">
                    付款
                    <span class="seckill-money-now">￥ {{ item.bizCharge }}</span>
                    <!-- <span class="seckill-money-or">￥ {{ item.bizCharge}}</span> -->
                  </div>
                  <div class="seckill-time-box" >
                   <span class="s-t1">关键字:</span>
                   <span class="s-t2" >
                      <b v-for="(kw, i) in item.keywords" :key="i">{{ kw.key.length>4? (kw.key.substring(0, 4)+'...') :kw.key }}</b>
                   </span></div><div class="seckill-buy-btn" @click="seckillBuy(item)">立即购买</div>                 
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-pagination-sk swiper-pagination"></div>
  </div>
</template>

<script>
import {Row, Col, ImagePreview, Toast} from 'vant'
import { getBizFile, addDownloadCount, createOrder, creatOrderInfo, checkDownloadAuth, dealAwaitOrder, getOrderInfoByOrderNo, queryCreateOrderNo } from '@/api/solutions/solution'
import { toLogin, isLogin } from '@/utils/common'
import { setCookie, getCookie, removeCookie } from '@/utils/cookies'
import { getSeckillList,getTopList } from '@/api/solutions/solution'
import miniProgramPayment from '@/mixins/miniProgramPayment'
export default {
  name: 'noResult',
  mixins: [miniProgramPayment],
  data () {
    return {
      defaultImg: '../assets/images/icon_user.png',
      nowTime: 0,
      seckillList: [],
      orderNo: '',
      ajaxNum: 0,
      orderId: 0,
      swiperOption: {
        loop: true,
        autoplay: true,
        pagination: {
          el: '.swiper-pagination-sk',
          type: 'bullets'
        }
      },
      swiperOptionOne: {
        observer: true,
        autoplay: true,
        loop: false
      }

    }
  },
  mounted () {
    this.getSeckill()
  },
  methods: {
    async seckillBuy (item) {
      if (!isLogin()) {
        toLogin()
      }
      this.toast = Toast.loading({
        message: '提交中...',
        forbidClick: true,
        duration: 0
      })
      let obj = {
        userId: getCookie('accountId') || getCookie('AccountId'),
        businessId: item.bizId,
        businessType: 1
      }
      let orderStatus = await checkDownloadAuth(obj)
      if (orderStatus.data.respCode === '0000' && orderStatus.status === 200) {
        if (orderStatus.data.data && orderStatus.data.data.plusUser == 1) {
          // 跳转下载页面
          this.$router.push(`/downloadFree/${item.bizId}.html`)
        } else if (orderStatus.data.data && !orderStatus.data.data.hasPayOrder) {
          this.createBuy(item)
        } else {
          this.toast.clear()
          if (orderStatus.data.data) {
            var orStatus = orderStatus.data.data.status
            var payStatus = orderStatus.data.data.payStatus
            switch (orStatus) {
              case 20:
                // 支付待审核
                if (payStatus) {
                  if (payStatus == 2) {
                    this.doAwaitOrder(orderStatus.data.data.orderNo, item)
                  }
                  if (payStatus == 3) {
                    Toast('当前订单审核中，请稍等！')
                  }
                  if (payStatus == 1) {
                    this.doAwaitOrder(orderStatus.data.data.orderNo, item)
                  }
                } else {
                  this.doAwaitOrder(orderStatus.data.data.orderNo, item)
                }
                break
              case 30:
                // 跳转下载页面
                this.$router.push(`/downloadFree/${item.bizId}.html`)
                break
              case 40:
                this.doAwaitOrder(orderStatus.data.data.orderNo, item)
                break
              case 50:
                // 已取消订单不具备下载权限，重新创建秒杀订单。
                this.createBuy(item)
                break
              case 60:
                this.doAwaitOrder(orderStatus.data.data.orderNo, item)
                break
              case 70:
                this.doAwaitOrder(orderStatus.data.data.orderNo, item)
                break
            }
          }
        }
      } else {
        this.toast.clear()
      }
    },
    async doAwaitOrder (orderNo, item) {
      let param = {
        businessId: item.bizId,
        businessName: item.bizName,
        businessType: 1,
        userId: getCookie('accountId')  || getCookie('AccountId'),
        os : $HMD$.rNavigator && $HMD$.rNavigator == 'msite' ? 'wap' : $HMD$.rNavigator,
        orderNo: orderNo
      }

      if ($HMD$.rNavigator !== 'msite' && !param.userId) {
        param.userId = await this.getAppAccountId()
      }
      dealAwaitOrder(orderNo, param).then(res => {
        if (res.status === 200 && res.data.respCode === '0000') {
          if (this.isMiniProgram()) {
            this.getOrderIdToMiniProgram(orderNo)
          } else if (window.$HMD$.rNavigator.toLowerCase() === 'ios') {
            this.getOrderIdToIos(orderNo, res.data.data.url)
          } else {
            window.location.href = res.data.data.url
          }
        } else {
          Toast('抱歉，下载权限校验失败!')
        }
      })
    },
    getOrderIdToIos (orderNo, jumpUrl) {
      getOrderInfoByOrderNo(orderNo).then((res) => {
        if (res.data.code !== 1000 && res.data.msg === '处理成功') {
          // eslint-disable-next-line no-undef
          $HMD$.M.sendApp({
            'name': 'FangAnGuanOrderId',
            'orderId': res.data.code && res.data.code.toString()
          })
        }
        window.location.href = jumpUrl
      })
    },
    getAppAccountId () {
      return new Promise((resolve, reject) =>{
        $HMD$.GetLogin(function (data) {
          resolve(data && data.AccountId || '')
        })
      });
    },
    async createBuy (item) {
      await this.getCreateOrderNo()
      this.ajaxNum = 0
      this.postCreatOrderInfo(item)
      console.log(this.orderNo)
    },
    // 获取平台唯一销售订单编号orderNo
    async getCreateOrderNo () {
      let res = await queryCreateOrderNo()
      if (res.status !== 200) {
        return
      }
      if (res.data.respCode !== '0000') {
        return
      }
      this.orderNo = res.data.respDesc
    },
    // 创建平台订单信息
    async postCreatOrderInfo (item) {
      let postData = {
        amount: item.bizCharge,
        hebiAmount: 0,
        orderNo: this.orderNo,
        businessId: item.bizId,
        businessName: item.bizName,
        businessType: 1, 
        couponAmount: 0,
        os: $HMD$.rNavigator && $HMD$.rNavigator == 'msite' ? 'wap' : $HMD$.rNavigator,
        userId: getCookie('accountId') || getCookie('AccountId'),
        orderNo: this.orderNo
      }
      if ($HMD$.rNavigator !== 'msite' && !postData.userId) {
        postData.userId = await this.getAppAccountId()
      }
      creatOrderInfo(postData).then(res => {
        if (res.data && res.data.respCode === '0000') {          
        } else {
          // Toast(res.data.respDesc, '服务异常')
        }
      })
      this.queryOrderInfoByOrderNo(postData);
    },
    // 轮询接口,前端调用的查缓存接口
    async queryOrderInfoByOrderNo (postData) {
      let t = setInterval(() => {
        this.ajaxNum += 1
        getOrderInfoByOrderNo(postData.orderNo).then((res) => {
          if (this.ajaxNum > 9) {
            this.toast.clear()
            clearInterval(t)
          }
          if (res.data.code !== 1000 && res.data.msg === '处理成功') {
            clearInterval(t)
            this.orderId = res.data.code
            this.createNewOrderLast(postData)
          }
        })
      }, 1000)
    },
    // 创建订单,页面跳转
    async createNewOrderLast (postData) {
      postData.orderNo = this.orderId
      createOrder(postData).then(count => {
        this.toast.clear()
        if (postData.amount === 0 && count.status === 200 && count.data && count.data.respCode === '0000') {
          this.$router.push(`/solutions/detail/${postData.businessId}.html`)
          return
        }
        if (count.status !== 200) {
          Toast('请检查网络')
          return
        }
        if (count.status === 200 && count.data && count.data.respCode !== '0000') {
          Toast(count.data.respDesc)
          return
        }
        if (count.status === 200 && count.data && count.data.respCode === '0000') {
          if (this.isMiniProgram()) {
            this.redirectToMiniProgramPayment(this.orderId)
            return
          }
        }
        if (count.status === 200 && count.data && count.data.respCode === '0000' && count.data.data && count.data.data.url) {
          // eslint-disable-next-line no-undef
          if ($HMD$.rNavigator.toLowerCase() === 'ios') {
            // eslint-disable-next-line no-undef
            $HMD$.M.sendApp({
              'name': 'FangAnGuanOrderId',
              'orderId': this.orderId && this.orderId.toString()
            })
          }
          window.location.href = count.data.data.url
        }
      })
    },
    getSeckill () {
      getTopList().then((res) => {
        if (res && res.data && res.data.respCode === '0000') {
          this.seckillList = res.data && res.data.data && res.data.data.records
        
          console.log(this.seckillList)
          // this.seckillController()
        }
      })
    },
    // 时间的掌控者  掌握时间的秩序
    seckillController () {
      setInterval(() => {
        this.nowTime = this.nowTime + 1000
        let list = this.seckillList.map(item => {
          let seckillState = this.getSeckillState(item.startTimeNumber, item.endTimeNumber)
          return {
            ...item,
            seckillState: seckillState,
            timeText: this.getTimeText(seckillState, item.startTimeNumber, item.endTimeNumber)
          }
        })
        this.seckillList = JSON.parse(JSON.stringify(list))
      }, 1000)
    },
    getSeckillState (startTimeNumber, endTimeNumber) {
      // 1未开始  2 进行中  3 已结束
      if (startTimeNumber > this.nowTime) return 1
      if (this.nowTime >= startTimeNumber && this.nowTime < endTimeNumber) return 2
      return 3
    },
    getTimeText (seckillState, startTimeNumber, endTimeNumber) {
      if (seckillState === 1) {
        return this.computTime(startTimeNumber - this.nowTime)
      }
      if (seckillState === 2) {
        return this.computTime(endTimeNumber - this.nowTime)
      }
      return ''
    },
    computTime (subTime) {
      const days = Math.floor(subTime / (24 * 3600 * 1000))
      const leave1 = subTime % (24 * 3600 * 1000)
      let hours = Math.floor(leave1 / (3600 * 1000))
      const leave2 = leave1 % (3600 * 1000)
      let minutes = Math.floor(leave2 / (60 * 1000))
      const leave3 = leave2 % (60 * 1000)
      let seconds = Math.round(leave3 / 1000) || ''
      hours = hours < 10 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds
      if (days > 0) {
        return days + '天 ' + hours + '时 ' + minutes + '分 ' + seconds + '秒 '
      } else if (hours > 0) {
        return '0天 ' + hours + '时 ' + minutes + '分 ' + seconds + '秒'
      } else if (minutes > 0) {
        return '0天 00时' + minutes + '分 ' + seconds + '秒'
      } else {
        return '0天 00时 00分' + seconds + '秒'
      }
    },
    goDetail (item) {
      this.$router.push(`/solutions/detail/${item.bizId}.html`)
    }
  }
}
</script>

<style lang="scss">
  .limit-seckill {
    width: 343px;
    margin: 16px auto 0;
    background: #ffffff;
    border-radius: 8px;
    box-sizing: border-box;
    position: relative;
    .limit-seckill-top {
      width: 327px;
      margin: 0 auto;
      height: 40px;
      border-bottom: 1PX solid #f2f2f2;
      display: flex;
      align-items: center;
      color: #FF6900;
      font-weight: bold;
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
      }
    }
    .seckill-item {
      width: 343px;
      height: 121px;
      backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      -webkit-overflow-scrolling: touch;
      .seckill-project-left {
        height: 101px;
        display: flex;
        align-items: center;
        img {
          width: 52px;
          height: 73px;
          height: auto;
        }
      }
      .seckill-project-right {
        height: 101px;
        flex: 1;
        padding: 12px 0 0 8px;
        box-sizing: border-box;
        position: relative;
        .seckill-info-title {
          width: 260px;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
          font-size: 15px;
          font-weight: bold;
          color: rgba(0,0,0,0.65);
          padding-bottom: 6px;
          line-height: 18px;
        }
        .seckill-money-box {
          padding-top: 6px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #000;
          line-height: 15px;
          .seckill-money-now {
            color: #FF0000;
          }
          .seckill-money-or {
            margin-left: 10px;
            text-decoration:  line-through;
            color: #a0a0a0;
            transform: scale(.9);
          }
        }
        .seckill-time-box {
          padding-top: 12px;
          display: flex;
          align-items: center;
          color: #222222;
          & > img {
            width: 12px;
            height: 12px;
            margin-right: 2px;
          }
          .seckill-item-text {
            font-size: 12px;
            transform: scale(.9);
          }
        }
        .seckill-buy-btn {
          position: absolute;
          top: 36px;
          right: 12px;
          width: 79px;
          height: 27px;
          background: linear-gradient(90deg,#ffa200, #ff6900, #ff6900);
          border-radius: 14px;
          font-size: 12px;
          color: #ffffff;
          line-height: 27px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }
        .wait {
          background: #8cb8ff;
        }
        .end {
          background: #d8d8d8;
        }
      }
    }
    
    .swiper-wrapper {
      backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      -webkit-overflow-scrolling: touch;
    }

    .swiper-pagination-sk {
      bottom: 6px;
      left: 0;
      right: 0;
      margin: auto;
    }
    .swiper-pagination-bullet {
      width: 4px;
      height: 4px;
      opacity: 1;
      background: rgba(29,111,233,0.30);
      border-radius: 2px;
      margin: 0 2px;
    }
    .swiper-pagination-bullet-active {
       width: 12px;
      height: 4px;
      opacity: 1;
      background: #1d6fe9;
      border-radius: 2px;
    }
    .van-swipe__track {
      height: 121px!important;
      backface-visibility: hidden;
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      -webkit-overflow-scrolling: touch;
    }
    .van-swipe__indicators {
      bottom: 12px;
    }
    .van-swipe__indicator {
      width: 4px;
      height: 4px;
      opacity: 1;
      background: rgba(29,111,233,0.30);
      border-radius: 2px;
    }
    .van-swipe__indicator--active {
      width: 12px;
      height: 4px;
      opacity: 1;
      background: #1d6fe9;
      border-radius: 2px;
    }
    .seckill-project {
      width: 343px;
      height: 101px;
      padding: 0 12px 0 17px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .s-t1{
    font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 12px;
color: #333333;
line-height: 22px;
text-align: left;
font-style: normal;
  }
  .s-t2{
    b{
      font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 12px;
color: #FF6900;
line-height: 22px;
text-align: center;
font-style: normal;
padding-left: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/limitSeckill2.vue